/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetShiftSignupsSelfQueryVariables = Types.Exact<{
  event_id: Types.Scalars["Int"];
}>;

export type GetShiftSignupsSelfQuery = {
  myVolunteerShiftSignups: Array<
    Pick<Types.ShiftSignup, "shift_id" | "checked_in" | "event_attendee_id"> & {
      shift: Pick<
        Types.EventActivity,
        "start_time" | "end_time" | "name" | "location"
      >;
    }
  >;
};

export const GetShiftSignupsSelfDocument = gql`
  query GetShiftSignupsSelf($event_id: Int!) {
    myVolunteerShiftSignups(event_id: $event_id) {
      shift_id
      checked_in
      event_attendee_id
      shift {
        start_time
        end_time
        name
        location
      }
    }
  }
`;

/**
 * __useGetShiftSignupsSelfQuery__
 *
 * To run a query within a React component, call `useGetShiftSignupsSelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftSignupsSelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShiftSignupsSelfQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useGetShiftSignupsSelfQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetShiftSignupsSelfQuery,
    GetShiftSignupsSelfQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetShiftSignupsSelfQuery,
    GetShiftSignupsSelfQueryVariables
  >(GetShiftSignupsSelfDocument, baseOptions);
}
export function useGetShiftSignupsSelfLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetShiftSignupsSelfQuery,
    GetShiftSignupsSelfQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetShiftSignupsSelfQuery,
    GetShiftSignupsSelfQueryVariables
  >(GetShiftSignupsSelfDocument, baseOptions);
}
export type GetShiftSignupsSelfQueryHookResult = ReturnType<
  typeof useGetShiftSignupsSelfQuery
>;
export type GetShiftSignupsSelfLazyQueryHookResult = ReturnType<
  typeof useGetShiftSignupsSelfLazyQuery
>;
export type GetShiftSignupsSelfQueryResult = ApolloReactCommon.QueryResult<
  GetShiftSignupsSelfQuery,
  GetShiftSignupsSelfQueryVariables
>;
